import { FC } from "react";

import { styled } from "styled-components";
import { typography } from "@joinTrilo/ui/tokens";

const StyledBankWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;

    gap: 1.6rem;

    height: 4.8rem;
    flex: none;
`;

const StyledBankLogo = styled.img`
    max-height: 2.4rem;
    max-width: 2.4rem;
    min-width: 2.4rem;
`;

const StyledPaymentMethodText = styled.div`
    font: ${typography.fonts.subHeadingSmall};
`;

type Props = {
    name: string;
    logoUrl: string;
    disabled?: boolean;
};

const SelectedBank: FC<Props> = ({ name, logoUrl }) => (
    <>
        <StyledBankWrapper>
            <StyledBankLogo src={logoUrl} alt={`${name} logo`} />
            <StyledPaymentMethodText> {name}</StyledPaymentMethodText>
        </StyledBankWrapper>
    </>
);

export default SelectedBank;
